import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { eventsAPI } from '../../api/client';
import { dossierAPI } from '../../api/traceability';
import { EVENT_STATUS } from '../../lib/eventConstants';
import { fetchAllRows, STAGES } from '../../lib/traceability';
import { errorMessage } from '../../lib/evaluationIntegrity';
import Dossier from '../../components/traceability/Dossier';
import ReportDownload from '../../components/ReportDownload';

export default function ClientEvents() {
  const { id } = useParams();
  const [events, setEvents] = useState([]);
  const [dossier, setDossier] = useState(null);
  const [stage, setStage] = useState('antes');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let current = true;
    setLoading(true);
    setDossier(null);
    setEvents([]);
    setError('');
    (id ? dossierAPI.get(id).then(({ data }) => {
      if (current) { setDossier(data); setStage(STAGES[data.stage] ? data.stage : 'antes'); }
    }) : fetchAllRows(eventsAPI.list).then(data => { if (current) setEvents(data); }))
      .catch(err => { if (current) setError(errorMessage(err, 'No se pudieron cargar los eventos')); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [id, retry]);
  if (loading) return <p role="status">Cargando eventos…</p>;
  if (error) return <p role="alert">{error} <button onClick={() => setRetry(n => n + 1)}>Reintentar</button></p>;
  if (!id) return <section className="space-y-4"><h1 className="text-2xl font-bold">Eventos</h1>
    {!events.length && <p>Sin eventos disponibles.</p>}
    {events.map(event => <article className="soem-card p-4" key={event.id}>
      <Link to={`/cliente/eventos/${event.id}`}>{event.name || 'Evento'}</Link>
      {event.dates?.event_start && <p>Inicio: {Number.isFinite(Date.parse(event.dates.event_start))
        ? new Date(/^\d{4}-\d{2}-\d{2}$/.test(event.dates.event_start) ? `${event.dates.event_start}T12:00:00Z` : event.dates.event_start).toLocaleDateString('es-MX', { timeZone: 'America/Mexico_City', day: '2-digit', month: '2-digit', year: 'numeric' })
        : 'Fecha no disponible'}</p>}
      <p>{event.location?.name} · {STAGES[event.stage] || EVENT_STATUS[event.status]?.label || 'Estado no disponible'}</p>
    </article>)}
  </section>;
  const event = dossier?.event;
  if (!event) return <p>Expediente no disponible.</p>;
  return <section className="space-y-4">
    <Link to="/cliente/eventos">Volver a eventos</Link>
    <h1 className="text-2xl font-bold">{event.name}</h1>
    <nav aria-label="Etapas del expediente">{Object.entries(STAGES).map(([key, label]) =>
      <button className="soem-btn-secondary p-2" key={key} aria-pressed={key === stage}
        onClick={() => setStage(key)}>{label}</button>)}</nav>
    <Dossier dossier={dossier} stage={stage} event={event} user={{ role: 'cliente' }} canEdit={false} />
    {stage === 'despues' && <ReportDownload eventId={id} role="cliente" />}
  </section>;
}
